import { computed, watch, type Ref } from 'vue'
import {
  type GatTextAreaProps,
  type GatTextAreaModelValue,
  type GatTextAreaEmits
} from './gat-textarea-edit.vue'

export function updateGatTextEditValue(
  value: GatTextAreaModelValue,
  lowerCase = false,
  upperCase = false
): GatTextAreaModelValue {
  let newValue = value
  if (newValue) {
    // To upper case
    if (upperCase) {
      newValue = newValue.toUpperCase()
    }
    if (lowerCase) {
      newValue = newValue.toLowerCase()
    }
  } else {
    // If it is an empty string, return null (for database purposes)
    newValue = undefined
  }
  return newValue
}

export function useTextAreaModelValue(
  props: GatTextAreaProps,
  emit: GatTextAreaEmits,
  value?: Ref<GatTextAreaModelValue>
  // customLowerCase: ComputedRef<boolean>,
  // customUpperCase: ComputedRef<boolean>
) {
  const gatLowerCase = computed(() => /* customLowerCase.value || */ props.lowerCase)
  const gatUpperCase = computed(() => /* customUpperCase.value || */ props.upperCase)

  const textEditValue = computed({
    get: () => value?.value ?? props.modelValue,
    set: (value) => {
      const newValue = updateGatTextEditValue(value, gatLowerCase.value, gatUpperCase.value)
      if (
        newValue !== props.modelValue &&
        (typeof newValue === 'string' || newValue === undefined)
      ) {
        emit('update:modelValue', newValue)
      }
    }
  })

  watch(
    () => gatLowerCase.value,
    () => {
      textEditValue.value = updateGatTextEditValue(textEditValue.value)
    },
    {
      immediate: true
    }
  )
  watch(
    () => gatUpperCase.value,
    () => {
      textEditValue.value = updateGatTextEditValue(textEditValue.value)
    },
    {
      immediate: true
    }
  )

  return {
    textEditValue
  }
}
